<script lang="ts">
	import type { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';

	import { page } from '$app/state';
	import { brandsSlugs, mediaUrl } from '$lib';
	import { m } from '$lib/paraglide/messages';
	import emblaCarouselSvelte, { type EmblaCarouselSvelteType } from 'embla-carousel-svelte';

	import BigButton from '../BigButton.svelte';

	let {
		block,
	}: {
		block: BrandBlock[];
	} = $props();

	let emblaApi: EmblaCarouselType | undefined = $state();
	let canScrollLeft = $state(false);
	let canScrollRight = $state(false);

	function refreshEmblaStates(emblaApi: EmblaCarouselType) {
		canScrollLeft = emblaApi.canScrollPrev();
		canScrollRight = emblaApi.canScrollNext();
	}

	function onInit(e: CustomEvent<EmblaCarouselSvelteType>) {
		emblaApi = e.detail as EmblaCarouselType;

		refreshEmblaStates(emblaApi);

		emblaApi.on('scroll', refreshEmblaStates);

		emblaApi.on('reInit', refreshEmblaStates);
	}

	const options: EmblaOptionsType = {
		slidesToScroll: 8,
		breakpoints: {
			'(min-width: 768px)': {
				slidesToScroll: 7,
			},
		},
	};

	const brandSlug = brandsSlugs[page.data.store.language];
</script>

<div class="relative flex flex-col">
	<h2 class="mb-2 text-center text-2xl font-semibold text-neutral-900 uppercase">
		{m.all_our_brands()}
	</h2>

	{#if canScrollLeft || canScrollRight}
		<div class="absolute top-0 hidden self-end md:block">
			<button onclick={() => emblaApi?.scrollPrev()} aria-label="previous">
				<span
					class={[
						'icon-[mdi--chevron-left] text-2xl text-black',
						{ 'cursor-not-allowed opacity-50': !canScrollLeft },
						{ 'cursor-pointer opacity-100': canScrollLeft },
					]}
				></span>
			</button>
			<button onclick={() => emblaApi?.scrollNext()} aria-label="next">
				<span
					class={[
						'icon-[mdi--chevron-right] text-2xl text-black',
						{ 'cursor-not-allowed opacity-50': !canScrollRight },
						{ 'cursor-pointer opacity-100': canScrollRight },
					]}
				></span>
			</button>
		</div>
	{/if}

	<div class="flex items-center">
		{#if canScrollLeft || canScrollRight}
			<button
				class={[
					'icon-[mdi--keyboard-arrow-left] size-7 cursor-pointer text-black md:hidden',
					{ 'opacity-25': !canScrollLeft },
				]}
				aria-label="previous"
				onclick={() => emblaApi?.scrollPrev()}
			></button>
		{/if}

		<div
			use:emblaCarouselSvelte={{ options, plugins: [] }}
			onemblaInit={onInit}
			class="my-1 flex-1 overflow-hidden"
		>
			<div
				class="grid auto-cols-[50%] grid-flow-col grid-rows-4 items-center md:auto-cols-[calc(1/7*100%)] md:grid-rows-1"
			>
				{#each block as brand (brand.slug)}
					<a
						href="/{brandSlug}/{brand.slug}"
						class="p-6 opacity-30 transition-opacity hover:opacity-100 md:h-auto md:w-auto"
					>
						<img
							src={mediaUrl(page.data.store.media_base_url, `wysiwyg/brands/logos/${brand.logo}`)}
							alt={brand.name}
							class="m-auto"
							loading="lazy"
						/>
					</a>
				{/each}
			</div>
		</div>

		{#if canScrollLeft || canScrollRight}
			<button
				class={[
					'icon-[mdi--keyboard-arrow-right] size-7 cursor-pointer text-black md:hidden',
					{ 'opacity-25': !canScrollRight },
				]}
				aria-label="next"
				onclick={() => emblaApi?.scrollNext()}
			></button>
		{/if}
	</div>

	<div class="flex justify-center">
		<BigButton
			href="/{brandSlug}"
			class="bg-white! text-black! hover:bg-neutral-800! hover:text-white!"
			>{m.discover_all_our_brands()}</BigButton
		>
	</div>
</div>
